import { Seo } from '@frontend/shared/web';

import { ModuleStub } from '../../components/empty/ModuleStub';
import { Header } from '../../components/layout/Header';

export const LostFoundRoute = () => (
  <>
    <Seo title="Objets trouvés — Portail extranet" />
    <Header title="Objets trouvés" subtitle="Suivi et restitution" />
    <ModuleStub
      title="Objets trouvés"
      description="Workflow de déclaration chauffeur, traçabilité et organisation de la restitution."
    />
  </>
);
